import React from "react";
import { XCircleIcon, CheckCircleIcon, InformationCircleIcon } from "@heroicons/react/24/solid";

const VARIANT_STYLES = {
  error: {
    bg: "bg-red-50",
    text: "text-red-800",
    iconColor: "text-red-400",
    Icon: XCircleIcon,
  },
  success: {
    bg: "bg-green-50",
    text: "text-green-800",
    iconColor: "text-green-400",
    Icon: CheckCircleIcon,
  },
  info: {
    bg: "bg-indigo-50",
    text: "text-indigo-800",
    iconColor: "text-indigo-400",
    Icon: InformationCircleIcon,
  },
};

export function AlertMessage({ type = "error", message = "" }) {
  const variant = VARIANT_STYLES[type];
  

  if (!message) return null; // Si pas de message, rien à afficher

  return (
    <div className={`rounded-md ${variant.bg} p-4 mb-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <variant.Icon aria-hidden="true" className={`h-5 w-5 ${variant.iconColor}`} />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${variant.text}`}>{message}</h3>
        </div>
      </div>
    </div>
  );
}